import { logger } from '@gem/modules/logger';

import { buildModelError } from 'APP/model/error/errorBuilder';
import { EmptyResponseError } from 'APP/model/error/errors/EmptyResponseError';
import { mapIPersonalizedWorkspace } from 'APP/model/workspace/workspaceModel.mapper';
import {
  getUsersInWorkspaceRequest,
  getWorkspaceRequest,
  searchUsersInWorkspaceRequest,
} from 'APP/wsApi/wsAppApi/requests/workspaceRequests';

import { mapPersonalizedUserResponse } from '../user/userModel.b2b.mapper';
import {
  IPersonalizedWorkspace,
  ISearchUsersInWorkspaceRequest,
  IUsersInWorkspaceRequest,
  IWorkspace,
  IWorkspaceMember,
} from './workspaceModel.types';

export async function getWorkspace(): Promise<IPersonalizedWorkspace> {
  try {
    const response = await getWorkspaceRequest();

    if (response.type.case !== 'success' || !response.type.value.workspace) {
      throw new EmptyResponseError('getWorkspace', response);
    }

    return mapIPersonalizedWorkspace(response.type.value.workspace);
  } catch (error) {
    logger.get('API').error('workspace.getWorkspace', error);
    throw buildModelError(error);
  }
}

export async function getUsersInWorkspace(
  data: IUsersInWorkspaceRequest
): Promise<{ cursor?: string; users: IWorkspaceMember[] }> {
  try {
    const result = await getUsersInWorkspaceRequest(data);

    if (result.type.case !== 'success') {
      return { users: [] };
    }

    const users = result.type.value.users.map(({ user, role }) => ({
      user: mapPersonalizedUserResponse(user!),
      role,
    }));

    return { cursor: result.type.value.cursor, users };
  } catch (error) {
    logger.get('API').error('workspace.getUsersInWorkspace', error);
    return { users: [] };
  }
}

export async function searchUsersInWorkspace(data: ISearchUsersInWorkspaceRequest): Promise<{
  cursor?: string;
  users: IWorkspaceMember[];
}> {
  try {
    const result = await searchUsersInWorkspaceRequest(data);

    if (result.type.case !== 'success') {
      return { users: [] };
    }

    const users = result.type.value.users.map(({ user, role }) => ({
      user: mapPersonalizedUserResponse(user!),
      role,
    }));

    return { cursor: result.type.value.cursor, users };
  } catch (error) {
    logger.get('API').error('workspace.getUsersInWorkspace', error);
    return { users: [] };
  }
}

export async function updateWorkspace(data: Partial<IWorkspace>): Promise<Partial<IWorkspace>> {
  return data;
}

export async function changeOwnership(newOwnerId: string): Promise<boolean> {
  return true;
}

export async function promoteToAdmin(userIds: string[]): Promise<boolean> {
  return true;
}

export async function revokeFromAdmin(userIds: string[]): Promise<boolean> {
  return true;
}

export async function removeParticipants(userIds: string[]): Promise<boolean> {
  return true;
}
